import { RouteLocationRaw } from 'vue-router';

export const props = {
  to: {
    type: [String, Object] as RouteLocationRaw,
    default: '',
  },
};
